import Variables from "../assets/styleVariables"
export const MANAGER_MAIN_COLOR = Variables.colors.tertiary_800;
export const MANAGER_SECOND_COLOR = Variables.colors.tertiary_50;
export const CUSTODIAN_MAIN_COLOR = Variables.colors.primary_vivid;
export const CUSTODIAN_SECOND_COLOR = Variables.colors.primary_50;